<template minapp='mpx' xlang='wxml'>
  <wxs src="./select.wxs" module="tools"></wxs>
  <view class="page"> 
    <es-over-layout
      layout="{{['header', 'footer']}}"
      class="es-select"
      useDefaultNavbar="{{false}}"
      custom-main="custom-main"
      useBlankPage="{{loadInitDataFail}}"
      navbarClickLeft="{{confirm}}"
      blankPageType="{{ loadInitDataFail ? 'blank-page' :''}}"
    >
      <view slot="header" class="es-select__header">
        <!-- bind:click-left="toClosePage" -->
        <es-navbar
          wx:class="{{isManageSimple ? '' : 'es-select__navbar'}}"
          custom-class="es-select__navbar"
          title="{{isManageSimple ? '常用乘车人' : (title?('添加'+ title):'')}}"
          leftArrow="{{false}}"
        >
          <view wx:if="{{!isHideLeftArrow}}" slot="left">
            <es-icon size='24' color="#333333" name="angle-left"></es-icon>
          </view>
        </es-navbar>
        <view wx:if="{{maxContact && !isManageSimple}}" class="es-select__header-tip">
          <text>已选{{selectedNumber}}/{{maxContact}}人</text>
        </view>
        <view class="es-select__tips" wx:if="{{selectTips.text && !isExemption}}" wx:style="{{selectTips.style}}">{{selectTips.text}}</view>
      </view>
      <view class="es-select__scroll-container">
        <view>
          <!-- 添加出行人按钮 -->
          <view class="es-select__add" wx:if="{{true}}" >
            <add-button 
              text="{{'添加' + (isManageSimple ? '旅客' : title)}}" 
              bind:click="goToAdd" 
            />
          </view>
          <view class="es-select__content" wx:if="{{innerList&&innerList.length > 0}}">
            <es-card-del wx:for="{{innerList}}" bind:click-right="delData(item)" class="page-card">
              <view slot="mainContext" class="card">
                <view wx:if="{{!isManageSimple}}" class="card-left">
                  <view class="checkbox-container expand-click" bindtap="toggleCheckbox(item)">
                    <checkbox-icon 
                      checked="{{tools.isItemChecked(item, selectedContacts)}}" 
                      disabled="{{tools.isDisableSelect(item, selectedContacts, maxContact, need_card,selectContentConfig) 
                      || item.mobile_status !== '1' 
                      || item.user_status !== '1' 
                      || validatePhoneEmpty(item.mobile_no)}}" 
                    />
                  </view>
                </view>
                <view class="card-main">
                  <view class="card-title">
                    <text class="username">{{item.passenger_name}}</text>
                    <!-- 标签种类：本人、成人票、儿童票、学生票，待修改UI -->
                    <text wx:if="{{ +item.is_user_self }}" class="card-tag card-tag__self">本人</text>
                    <text wx:if="{{item.passenger_type === 0}}" class="card-tag">成人票</text>
                    <text wx:if="{{item.passenger_type === 1}}" class="card-tag">儿童票</text>
                    <text wx:if="{{item.passenger_type === 2}}" class="card-tag">学生票</text>
                    <text wx:if="{{item.passenger_source === 0}}" class="card-tag">12306</text>
                  </view>
                  <view class="card-info">
                    <!-- {{need_card}}
                    {{tools.isMissing(item, need_card, selectContentConfig)}} -->
                    <text wx:if="{{tools.isMissing(item, need_card, selectContentConfig)}}" class="card-tip">请补全身份信息</text>
                    <view>
                      <text>{{ item.id_name}}：</text>
                      <text wx:if="{{item.passenger_source === 1 && item.user_status === '3'}}" bindtap="goToSupply(item)" class="id-tip">证件信息已过期，请补齐<image mode="aspectFit" src="https://ut-static.udache.com/webx/sfc/q4PIMKjo34T6AnB_EIVEL_clipboard_image_1698899373437.png" class="id-tip-icon" /></text>
                      <text wx:else>{{tools.desensitizeCardId(item.encrypt_id_no) }}</text>
                    </view>
                  </view>
                  <!-- 核验结果 user_status 3.需要补齐身份证号  -->
                  <block wx:if="{{item.user_status !== '3'}}">
                    <!-- mobile_status String 手机核验状态 0:待核验;1:核验通过; 2:核验未通过。 -->
                    <!-- user_status String 资质核验状态 0:待核验;1:核验通过; 2:核验未通过。 -->
                    <view class="card-tip" wx:if="{{item.mobile_status !== '1' && item.user_status !== '1' }}" bindtap="jumpToValidateComment(item, 'identity')">联系方式、身份核验未通过<es-icon class="arrow" name="angle-right" size="16" color="#f93822" /></view>
                    <view class="card-tip" wx:if="{{item.mobile_status === '1' && item.user_status !== '1' }}" bindtap="jumpToValidateComment(item, 'identity')">身份核验未通过，请去车站窗口核验<es-icon class="arrow" name="angle-right" size="16" color="#f93822" /></view>
                    <view class="card-tip" wx:if="{{item.mobile_status !== '1' && item.user_status === '1'}}" bindtap="jumpToValidateComment(item, 'contact')">联系方式核验未通过<es-icon class="arrow" name="angle-right" size="16" color="#f93822" /></view>
                    <view class="card-tip" wx:elif="{{validatePhoneEmpty(item.mobile_no)}}" bindtap="goToEdit(item)">联系方式待填写<es-icon class="arrow" name="angle-right" size="16" color="#f93822" /></view>
                  </block>
                </view>
                <view class="card-right" bindtap="goToEdit(item)">
                  <es-icon name="pencil-edit" size="18" color="#999" />
                </view>
              </view>
              <view slot="delContext" class="del-box">
                <view>删除</view>
              </view>
            </es-card-del>
          </view>
        </view>
        <!-- <view wx:if="{{isLoading}}" class="bottom-tip">数据加载中...</view> -->
        <view wx:if="{{!innerList.length && !isFristLoad}}" class="no-data">
          <view>
            <image src="https://pt-starimg.didistatic.com/static/starimg/img/eXNx7tOkBo1644825801357.png" class="no-data-img" />
          </view>
          <view wx:if="{{isHasNoData && scene == '1' && keywords == ''}}">
            <view class="no-data-text">代订制度中未选择任何出行人</view>
            <view class="no-data-text">如有疑问请联系管理员进行更改</view>
          </view>
          <view wx:if="{{isHasNoData && scene == '2' && keywords == ''}}">
            <view class="no-data-text">预订请先添加出行人</view>
          </view>
        </view>
      </view>
      <view wx:if="{{!isManageSimple}}" slot="footer" class="es-select__footer">
        <es-button class="submit-button" custom-class="submit-button" block type='info' bind:click='confirm'>确定</es-button>
      </view>
    </es-over-layout>
    <es-toast id='es-toast' />
    <contact-dialog
      show="{{ isShowDialog }}"
      title="{{dialog_title}}"
      cancelText="知道了"
      content="{{content}}"
      bind:cancel="close"
      showClass="{{true}}"
      align="center"
    >
    </contact-dialog>
    <!-- 学生票二次确认弹窗 -->
    <student-confirm-dialog
      show="{{isShowStudentConfirmDialog}}"
      bind:cancel="clickBuyStudent"
      bind:confirm="clickBuyAdult"
    ></student-confirm-dialog>
    <!-- 学生票 坐席不符合学生票购买规定 -->
    <student-dialog
      show="{{isShowStudentDialog}}"
      bind:cancel="changeSeat"
      bind:confirm="clickBuyAdult"
    ></student-dialog>
    <!-- 儿童票弹窗 -->
    <child-dialog
      show="{{isShowChildDialog}}"
      bind:cancel="closeDialog"
    ></child-dialog>
    <!-- 删除乘车人弹窗 -->
    <es-dialog
			showConfirmButton
			showCancelButton
			show="{{isDeleteDialogShow}}"
			bind:close="confirmDelete"
		>
			<view slot="content"> 确认删除{{isExemption ? '常用旅客' : '联系人'}}{{ contactName }}吗? </view>
		</es-dialog>
    <!-- 补全信息弹窗 -->
    <supply-info
      supplyInfo="{{supplyInfo}}"
			bind:close="supplyClose"
			bind:confirm="supplyConfirm"
		/>
  </view>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import store from '@/store'
  import { debounce, desensitize, permitValidateConf } from '@/utils'
  import Validator from '@/utils/validator'
  import { AES_ECB_DECRYPT, AES_ECB_ENCRYPT } from '@/common/crypto'
  import { fetchContactDetail } from '@/api/contact/index'
  import { USER_CONTACTS_TOC, USER_DEL_TOC, USER_UPDATE_TOC } from '@/api/urls'
  import { travelerMergePassenger } from '@/api/passenger'
  import {
    PageSource,
    CategoryType,
    NeedCardType,
    SceneType,
    BusinessType,
    ApprovalType,
    EmployeeStatus,
    RuleType
  } from '@/utils/constants'
  import { DIDI_REQUEST, isWXMini, isALIMini } from '@/common/constant'
  import { contentConfig, titleConfig, selectedOverTipsConfig } from '@/config/content/index'
  import { isMissing } from '@/utils'
  import { innerRouter, pagePath, closePage } from '@/common/jump'
  import { trackEvent } from '@/common/track'

  createPage({
    data: {
      isDeleteDialogShow: false,
      toBeDeletedPassernger: {},
      originSelectInfo: [], // 页面初始化时, 就已勾选的乘车人
      keywords: '',
      page_no: 0,
      page_size: 10,
      total: 0,
      hasMore: true,
      isLoading: true,
      maxContact: 1,
      travelersSelected: [],
      need_card: NeedCardType.yes,
      scene: SceneType.forPersonal,
      category: CategoryType.hotel,
      categoryOverTipsConfig: '',
      title: '',
      need_approval: ApprovalType.no,
      need_type: BusinessType.self,
      approval_id: '',
      institution_id: '',
      isShowDialog: false,
      dialog_title: '',
      content: '',
      initSetContactSelected: [],
      hasConfirm: false,
      isFristSelectedContact: true,
      paramsArr: [],
      innerList: [],
      isBookingForSelf: 1, // 为自己预订
      isBookingForInside: 0, // 为内部员工预订
      isBookingForOutside: 0, // 为外部人员预订
      isNewDateSet: false,
      rule_owner: '', //差标执行人id
      loadInitDataFail: false, //是否加载失败
      isFristLoad: true, //是否是第一次加载
      isHasNoData: false, //是否第一次进入就没有数据
      isShowStudentConfirmDialog: false, // 是否展示学生票二次确认弹窗
      isShowStudentDialog: false, // 是否展示学生票,不符合要求的,弹窗二次确认弹窗
      isShowChildDialog: false, // 是否展示儿童票弹窗
      supplyInfo: {}, // 需要补全信息的乘车人信息
    },

    computed: {
      isManageSimple() {
        return this.$mpxRoute.query?.manage === '1'
      },
      isHideLeftArrow() {
        return isWXMini || isALIMini
      },
      selectContentConfig() {
        // console.log(contentConfig[this.category],this.category,'=====selectContentConfig===');
        return contentConfig[this.category]
      },
      contactName() {
        return this.toBeDeletedPassernger?.passenger_name ?? ''
      },
      selectedNumber() {
        let selectArrLength = 0
        if (Array.isArray(this.selectedContacts)) {
          selectArrLength = this.selectedContacts.length
        }
        return selectArrLength
      },
      ...store.mapState({
        permission: 'newContacts.permission',
        refreshUserId: 'newContacts.refreshUserId',
        selectedContacts: 'newContacts.selectedContacts',
        externalContacts: 'newContacts.externalContacts',
        contactDetail: 'newContacts.contactDetail',
        selectSeatInfo: 'train.selectSeatInfo',
        is12306Login: 'login12306.is12306Login',// 是否已登录12306
      }),
      ...store.mapGetters({
        isExemption: 'makeOrder.isExemption',
      }),
      params() {
        // 因公，需要审批单
        if (this.scene == SceneType.forBusiness && this.need_approval == NeedCardType.yes) {
          return {
            page_size: 10,
            page_no: this.page_no,
            id: this.approval_id,
            category: this.category
          }
          // 因公，无须审批 || 因私
        } else {
          const type = this.scene == SceneType.forBusiness ? 2 : 3
          return {
            type: type, // 2: 因公常用出行人 3: 因私常用出行人
            // is_new: 1, // 代订需求后必传
            // category: this.category,
            need_card: this.need_card,
            // scene: this.scene,
            page_size: 10,
            page_no: this.page_no,
            // need_type: this.need_type,
            // institution_id: this.institution_id,
            // source: PageSource.select,
            services: RuleType[this.category]?.toString(),
            booking_myself: this.isBookingForSelf,
            booking_inside: this.isBookingForInside,
            booking_outside: this.isBookingForOutside,
            category: this.category
          }
        }
      },

      // 是否是因私差旅
      isPersonalTravel() {
        return this.scene === SceneType.forPersonal
      },

      isShowAddButton() {
        // 如果不展示外部员工，不展示添加按钮
        if (this.scene == SceneType.forBusiness && this.isBookingForOutside == false) {
          return false
        }
        // 1. 因私
        // 2. 因公，无须审批，且登录用户有添加权限
        return (
          this.isPersonalTravel ||
          (!this.isPersonalTravel && this.need_approval == ApprovalType.no && this.permission)
        )
      },

      selectTips() {
        return {
          text: '根据有关部门规定，乘客须补齐证件信息、联系方式并完成核验',
          style: {}
        }
      },
      passengerSource() {
        let _passengerSource = 0
        if(this.isExemption === 1 || !this.is12306Login) _passengerSource = 1
        return _passengerSource
      },
    },

    methods: {
      ...store.mapMutations({
        // setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
        setContactVerifyParams: 'newContacts.setContactVerifyParams',
        setContactSelected: 'newContacts.setContactSelected',
        setExternalContacts: 'newContacts.setExternalContacts',
        contactDetailSuccess: 'newContacts.contactDetailSuccess',
        removeContactSelected: 'newContacts.removeContactSelected',
        clearContactDetail: 'newContacts.clearContactDetail',
      }),

      ...store.mapActions({
        checkPermissionAction: 'newContacts.checkPermissionAction'
      }),

      // 点击删除后逻辑
      delData(item) {
        this.toBeDeletedPassernger = item
        this.isDeleteDialogShow = !this.isDeleteDialogShow
      },

      // 左滑删除乘车人
      confirmDelete({ detail }) {
        this.isDeleteDialogShow = !this.isDeleteDialogShow
        if (detail === 'confirm') {
          mpx.$http
            .post(USER_DEL_TOC, {
              data: {
                contact_id: this.toBeDeletedPassernger?.id ?? '',
                order_type: this.toBeDeletedPassernger.passenger_source,
                user: {
                  passenger_name: this.contactName,
                  id_no: this.toBeDeletedPassernger?.id_no ?? '',
                  id_type: this.toBeDeletedPassernger?.id_type ?? ''
                }
              }
            })
            .then((res) => {
              if (+res?.code !== 0 || !res?.data?.is_success) {
                Toast({
                  message: res?.data?.msg || res.message,
                  overlay: false
                })
              } else {
                const del_id = this.toBeDeletedPassernger?.id
                // 删除之后同步移除已选择的乘车人
                this.removeContactSelected(del_id)
                this.originSelectInfo = this.originSelectInfo?.filter(({ id }) => id != del_id)
                this.innerList = this.innerList?.filter(({ id }) => id != del_id)
                Toast({
                  message: res?.data?.msg ?? '删除成功',
                  overlay: false,
                  duration: 1000
                })
                if (res?.data?.is_success) {
                  setTimeout(() => this.search(), 300)
                }
              }
            })
        }
      },

      upgradeSelectedContact(params) {
        //更新初始化数据
        // let res;
        return getSelectedContact({
          contact_list: JSON.stringify(params),
          category: this.category,
          show_loading: false
        }).then((res) => {
          if (res.code == 0) {
            let tempData = res.data || []
            return tempData
          }
        })
        // onsole.log("res",res)
        // return res
      },

      desensitizeName(val) {
        return desensitize(val, 1, -1)
      },
      goBack() {
        innerRouter.goback()
      },
      contactClick(curItem) {
        const { id, card_type, card_list } = curItem

        if (id === this.rule_owner) {
          Toast({
            message: '执行制度所属出行人默认选中不可取消',
            overlay: false
          })
          return
        }
        this.setContactSelected({ data: curItem, fn: 'reduce' })
      },
      toClosePage(){
        this.isManageSimple && closePage()
      },
      confirm() {
        trackEvent('user-contant-select', '排查--用户乘车人选择', {
          list: JSON.stringify(this.selectedContacts)
         })
        if (!this.selectedContacts.length) {
          Toast({
            message: '您没有选择任何人',
            overlay: false
          })
          return
        }
        const isOnlyChild = this.checkIsChild()
        if (isOnlyChild) {
          return
        }
        // 上传下载
        if(this.selectedContacts.length) {
          const traveler_info = this.selectedContacts.filter(({passenger_source}) => {
            return passenger_source === 0
          }).map(passerger12306 => ({
            id: passerger12306.id,
            status: passerger12306.passenger_source,
            passenger_name: passerger12306.passenger_name,
            passenger_type: passerger12306.passenger_type,
            sex: passerger12306.sex,
            born_date: passerger12306.born_date,
            country_code: passerger12306.country_code,
            mobile_no: passerger12306.mobile_no,
            id_type: passerger12306.id_type,
            id_no: passerger12306.id_no,
            id_name: passerger12306.id_name,
          }))
          traveler_info.length && travelerMergePassenger({
            traveler_info: JSON.stringify(traveler_info),
            order_type: this.passengerSource,
          })
        }
        this.hasConfirm = true
        this.goBack()
      },

      close() {
        this.isShowDialog = false
      },

      goToAdd() {
        // 新增列表人数判断
        const isAdd = this.addValidate()
        if(isAdd) {
          const uniquePassengerKeys = this.innerList.map(({
            passenger_name,
            passenger_type,
            id_type,
            encrypt_id_no
          }) => {
            const slice_encrypt_id_no = encrypt_id_no.substring(0,4) + encrypt_id_no.slice(-3)
            return passenger_name + passenger_type + id_type + slice_encrypt_id_no
          })
          innerRouter.push(pagePath().CONTACTADD, {
            need_card: this.need_card,
            source: PageSource.select,
            scene: this.scene,
            category: this.category,
            isDelay: true,
            uniquePassengerKeys
          })
        }
      },
      // 添加乘客拦截
      addValidate() {
        let isValide = true
        if (this.innerList.filter(({passenger_source}) => passenger_source === 0).length >= 15) {
          this.isShowDialog = true
          this.dialog_title = '温馨提示'
          this.content =
            '乘车人数量已达上限，请删除后添加'
          isValide = false
        }

        return isValide
      },
      goToSupply(item) {
        this.supplyInfo = {
          ...item
        }
      },
      supplyClose() {
        this.supplyInfo = {}
      },
      async supplyConfirm({ detail }) {
        const {
          originData,
          new_id_no
        } = detail
        let errorMsg
        if(!new_id_no) {
          errorMsg = '请填写身份证'
        }else {
          const validator = new Validator()
          const validateConf = permitValidateConf({code:'1'})
          validator.cbAdd(new_id_no, validateConf, '请输入正确的证件号码')
          errorMsg = validator.start()
        }
        if(errorMsg) {
          mpx.showToast({
            title: errorMsg,
            icon: 'none',
            mask: true,
          })
          return
        }

        const res = await mpx.$http.post(USER_UPDATE_TOC, { 
          data: {
            user: {
              ...originData,
              id: String(originData.id),
              is_user_self: Boolean(+originData.is_user_self),
              id_no: AES_ECB_ENCRYPT(new_id_no),
              born_date: originData.born_date ? AES_ECB_ENCRYPT(originData.born_date) : undefined,
              encrypt_id_no: undefined
            },
            order_type: 1
          },
        })
        if (+res?.code) {
          mpx.showToast({
            title: res?.message || '网络错误, 请稍后重试',
            icon: 'none',
            mask: true,
          })
        } else {
          mpx.showToast({
            title: '核验成功',
            icon: 'none',
            mask: true,
          })
          this.supplyClose()
          this.search()
        }
      },

      goToEdit(item) {
        const { id, card_list, sub_type, status, is_tmp_traveler, btnIsOpen, passenger_source } = item
        // 离职员工
        if (item.status == EmployeeStatus.leave) {
          return
        }

        let card_type

        if (card_list && card_list.length > 0) {
          card_type = card_list[0].card_type
        }

        const params = {
          userId: id,
          card_type,
          sub_type,
          need_card: this.need_card,
          source: PageSource.select,
          scene: this.scene,
          category: this.category,
          is_tmp_traveler,
          btnIsOpen,
          isDelay: true,
          passenger_source
        }

        if (this.scene == SceneType.forBusiness) {
          params.need_approval = this.need_approval
        }
        if (is_tmp_traveler) {
          this.contactDetailSuccess({ data: item })
        }
        innerRouter.push(pagePath().CONTACTEDIT, params)
      },

      toggleCheckbox(item) {
        const { id, card_type, card_list, personal_secret_key, mobile_status, user_status, passenger_source } = item

        if(passenger_source === 1 && user_status === '3') {
          this.goToSupply(item)
          return
        }

        // 如果核验未通过, 该乘车人无法选取
        if (+mobile_status !== 1 || +user_status !== 1 || this.validatePhoneEmpty(item.mobile_no || '')) return

        if (id === this.rule_owner) {
          Toast({
            message: '执行制度所属出行人默认选中不可取消',
            overlay: false
          })
          return
        }

        //需要补全信息
        if (isMissing(item, this.need_card, this.selectContentConfig)) {
          return
        }

        const idIndex = this.selectedContacts.findIndex((item) => item.id == id)
        // TODO 这块需要吗？
        if (idIndex === -1) {
          //添加验证证件号是否重复
          const isSameCard = this.selectedContacts.find((item) => {
            let cardNo = item.card_list?.[0]
            let curCardNo = card_list?.[0]
            if (!cardNo || !curCardNo) return
            let DecryptCardNo = AES_ECB_DECRYPT(cardNo.secret_card_no, item.personal_secret_key)
            let DecryptCurCardNo = AES_ECB_DECRYPT(curCardNo.secret_card_no, personal_secret_key)
            return DecryptCardNo === DecryptCurCardNo && cardNo?.card_type === curCardNo?.card_type
          })

          if (isSameCard) {
            let isSameCardName =
              isSameCard.passenger_name || isSameCard.english_name + '/' + isSameCard.english_surname
            let curCardName = item.passenger_name || item.english_name + '/' + item.english_surname
            this.dialog_title = ''
            this.content = isSameCardName + '、' + curCardName + '证件号码重复，请核对修改。'
            this.isShowDialog = true
            return
          }
        }
        // 超过最大可选人数，不可选
        if (this.selectedContacts.length === this.maxContact && idIndex === -1) {
          let selectedOverTips = selectedOverTipsConfig[this.categoryOverTipsConfig]
          let tips = ''
          if (this.maxContact < selectedOverTips.maxNumber) {
            tips = selectedOverTips.noOverTips
          } else {
            tips = selectedOverTips.overTips
          }
          return Toast({
            message: tips,
            overlay: false
          })
        }
        //原维护的选中的数据
        if (idIndex === -1) {
          if (this.selectedContacts.length < this.maxContact) {
            // 12306学生票检查
            !this.isExemption && this.checkIsStudent(item)
            this.setContactSelected({ data: item, fn: 'add' })
          }
        } else {
          this.setContactSelected({ data: item, fn: 'reduce' })
        }
      },
      // 检查是否勾选了学生票
      checkIsStudent(item) {
        const selectSeatInfo = this.selectSeatInfo || []
        const curSeatType = selectSeatInfo?.map(item => item.seat_type)

        // 学生优惠坐席
        // 1: 硬座、无座 3: 硬卧 O: 二等座 无座：0
        const indulgenceArr = ['1', '3', '0', 'O']
        if (item.passenger_type === 2 && item.passenger_source === 0) {
          if (curSeatType.every(seat=> indulgenceArr.includes(seat))) {
            this.isShowStudentConfirmDialog = true
          } else {
            this.isShowStudentDialog = true
          }
        }
      },
      // 购买学生票
      clickBuyStudent(e) {
        console.log('clickBuyStudent', this.selectedContacts)
        this.closeDialog()
      },
      // 购买成人票
      clickBuyAdult() {
        const { selectedContacts } = this
        const newSelectedContacts = []
        this.selectedContacts.map((item, index) => {
          const newItem = { ...item }
          if (index === selectedContacts.length - 1) {
            newItem.passenger_type = 0
          }
          newSelectedContacts.push(newItem)
        })
        this.setContactSelected(newSelectedContacts)
        this.closeDialog()
        console.log('clickBuyAdult', newSelectedContacts)
      },
      // 检查是否只勾选了儿童票
      checkIsChild() {
        let isOnlyChild = false
        const selectedContacts = this.selectedContacts || []

        // 产品逻辑：儿童必须存在成人陪同, 学生也不行, 不过学生买成人票, 就没问题
        // 这里存在两个判断, 一、存在儿童 二、存在成人
        isOnlyChild =
          selectedContacts?.some((item) => +item?.passenger_type === 1) &&
          !selectedContacts?.some((item) => +item?.passenger_type === 0)

        if (isOnlyChild) {
          this.isShowChildDialog = true
        }

        return isOnlyChild
      },
      // 关闭自定义弹窗
      closeDialog() {
        this.isShowChildDialog = false
        this.isShowStudentConfirmDialog = false
        this.isShowStudentDialog = false
      },
      // 修改坐席
      changeSeat() {
        innerRouter.goback(2)
      },
      // 获取用户乘客列表
      async getUserContactsList(cb) {
        return DIDI_REQUEST(
          USER_CONTACTS_TOC,
          {
            order_type: this.passengerSource,
            passenger_source: this.passengerSource,
          },
          ({ data, code, message }) => {
            if (+code === 0) {
              cb(data?.list ?? [])
            } else {
              mpx.showToast({
                title: message, //提示的内容,
                icon: 'error' //图标,
              })
            }
          },
          () => {}
        )
      },

      search: debounce(
        async function () {
          this.isLoading = true
          await this.getUserContactsList((list) => {
            if (!list?.length) {
              this.isHasNoData = true
            }
            this.innerList = list
          })
        },
        300,
        false
      ),

      /**
       * @description: 滚动到底部事件
       */
      onScrollToBottom: debounce(function (e) {
        if (this.isLoading) return
        if (this.hasMore) {
          this.page_no = this.page_no + 1
        }
      }, 300),

      setSelectContactsInExternal() {
        //改为列表全部数据的自己维护的外部出行人添加，而不是已选中
        this.innerList?.forEach((element) => {
          if (element.is_tmp_traveler) {
            this.setExternalContacts(element)
          }
        })
      },

      filterArr(paramsArr, contacts) {
        return (
          contacts?.filter((element) => {
            let temp = paramsArr?.filter((item) => {
              return item.id == element.id
            })
            return temp?.length
          }) || []
        )
      },
      /**
       * 跳转核验页面
       * identity: 跳转到身份核验页面
       * contact: 跳转到联系人核验页面
       */
      jumpToValidateComment(item, type) {
        // 记录当前乘车人信息
        this.setContactVerifyParams({ data: item })
        if (type === 'identity') {
          innerRouter.push(pagePath().IDENTITYVERIFYPAGE)
        } else if (type === 'contact') {
          innerRouter.push(pagePath().CONTACTVERIFYPAGE, {
            cur_username:
              this.innerList?.filter?.((item) => item?.is_user_self === '1')?.[0]?.passenger_name ||
              ''
          })
        }
      },
      // 校验乘车人手机号是否为空
      validatePhoneEmpty(phone) {
        return AES_ECB_DECRYPT(phone || '') === ''
      }
    },

    watch: {
      params() {
        if (this.hasMore) {
          this.search()
        }
      },
      contactDetail() {
        this.isNewDateSet = false
      },

      refreshUserId: {
        immediate: true,
        deep: true,
        handler(data) {
          if (data) {
            const idx = this.travelersSelected?.findIndex((item) => item.id == data)
            if (idx !== -1) {
              this.travelersSelected[idx].card_type = 0
            }
          }
        }
      }
    },

    mounted() {
      mpx.setNavigationBarColor({ frontColor: '#000000' })
      const {
        max,
        scene,
        selected,
        category,
        categoryOverTipsConfig,
        need_card,
        need_approval,
        need_type,
        institution_id,
        approval_id,
        rule_owner,
        booking_myself,
        booking_inside,
        booking_outside,
        manage
      } = this.$mpxRoute.query
      // if(manage === '1') {
      //   this.setMakeOrderLoginType(1)
      // }
      this.maxContact = Number(max) || 1 // 可选择人数
      this.category = category || CategoryType.hotel // 品类 flight hotel train
      this.categoryOverTipsConfig = categoryOverTipsConfig
      this.scene = scene || SceneType.forPersonal // 场景 1因公 2因私
      this.need_card = need_card || NeedCardType.yes // 是否需要证件信息 1是 0否
      // this.title = (title && decodeURIComponent(title))
      this.title = titleConfig[this.category] // 页面标题
      this.need_type = need_type || BusinessType.self // 为谁预订，本人、他人
      this.need_approval = need_approval || ApprovalType.no // 因公且代订模式下，是否需要审批
      this.institution_id = institution_id // 制度id
      this.approval_id = approval_id // TA单id
      this.rule_owner = rule_owner // 当前制度所属人，不可取消勾选
      this.isBookingForSelf = booking_myself // 为自己预订
      this.isBookingForInside = booking_inside // 为内部员工预订
      this.isBookingForOutside = booking_outside // 为外部人员预订
      this.originSelectInfo = this.selectedContacts || []

      // id和card_type组合字符串
      const idTypes = (selected && selected.split(',')) || []
      // 页面初始化时，清空历史数据 - 2023.06.06 先不清了, 以为是个 bug, 后续再看看
      // this.setContactSelected([])
      // 当前制度所属人默认为选中人
      // 提前获取差旅制度所属人的详情

      this.travelersSelected = idTypes.map((ele) => {
        const idType = ele.split('_')
        this.paramsArr.push({
          id: idType[0],
          sub_type: idType[2]
        })
        return {
          id: idType[0],
          card_type: idType[1]
        }
      })

      const index = this.travelersSelected.findIndex((item) => item.id == this.rule_owner)
      if (this.rule_owner && index === -1) {
        this.travelersSelected.push({
          id: this.rule_owner,
          card_type: 0
        })
        fetchContactDetail({
          id: this.rule_owner,
          sub_type: 1,
          category: this.category,
          show_loading: false
        }).then((res) => {
          if (res.code == 0) {
            // let allSelectedContacts = [{ data: res.data, fn: 'add' }, ...this.selectedContacts]
            this.setContactSelected({ data: res.data, fn: 'add' } || [])
          }
        })
      }

      console.log('初始化')
      //改为初始化时，重写数据
      // if (this.paramsArr.length !== 0) {
      // getSelectedContact({
      //   contact_list: JSON.stringify(this.paramsArr),
      //   category: this.category,
      //   show_loading: false
      // }).then((res) => {
      //   if (res.code == 0) {
      //     let tempArr = res.data || []

      //     //拼接临时外部出行人选中数据
      //     let selectedExternalContacts = this.externalContacts?.filter((element) => {
      //       let temp = this.travelersSelected.filter((item) => {
      //         return item.id == element.id
      //       })
      //       return temp.length > 0
      //     })

      //     //只有信息完善的出行人才会被选中，做兜底
      //     let initSelected = tempArr.filter((item) => {
      //       if (isMissing(item, this.need_card, this.selectContentConfig)) {
      //         return false
      //       }
      //       return true //需要补全信息
      //     })

      //     let allSelectedContacts = [
      //       ...this.selectedContacts,
      //       ...selectedExternalContacts,
      //       ...initSelected
      //     ]
      //     this.initSetContactSelected = JSON.parse(JSON.stringify(allSelectedContacts))
      //     this.setContactSelected(allSelectedContacts || [])
      //   }
      // })
      // }

      if (this.scene === SceneType.forBusiness && this.institution_id) {
        this.checkPermissionAction({
          institution_id: this.institution_id,
          need_type: this.need_type,
          show_loading: false
        })
      }
    },

    //隐藏的时候去把选中的临时出行人数据（可能是在TA单编辑的），放到自己维护的临时出行人数据里面
    onHide() {
      this.setSelectContactsInExternal()
    },
    async activated() {
      if (this.page_no === 1) {
        this.search()
      } else {
        this.page_no = 1
        this.search()
      }

      if (!this.isFristSelectedContact) {
        //凑出内存中已选中的出行人的参数
        let tempArr = []
        this.selectedContacts?.forEach((item) => {
          const { id, sub_type } = item
          tempArr.push({
            id,
            sub_type
          })
        })

        var initSetContactSelected = [] //更新初始化数据

        // tempArr为已选中参数，this.paramsArr为初始参数，两个请求合并在一起，减少请求次数，
        //返回结果也根据这个参数去拆分出来

        //对数组里面的对象进行过滤
        let obj = {}
        let params =
          [...this.paramsArr, ...tempArr]?.reduce((item, next) => {
            obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
            return item
          }, []) || []

        // await this.upgradeSelectedContact(params).then((res) => {
        //   initSetContactSelected = this.filterArr(this.paramsArr, res)
        //   contactSelected = this.filterArr(tempArr, res)
        // })

        //初始化数据的处理
        let initSelectedExternalContacts = this.filterArr(this.paramsArr, this.externalContacts)

        let allInitSelectedContacts = [...initSelectedExternalContacts, ...initSetContactSelected]
        this.initSetContactSelected = JSON.parse(JSON.stringify(allInitSelectedContacts))

        //更新临时外部出行人选中的数据的处理
        let selectedExternalContacts = this.filterArr(tempArr, this.externalContacts)
        let allSelectedContacts = [...selectedExternalContacts, ...this.selectedContacts]
        this.setContactSelected(allSelectedContacts || [])

        // //添加编辑/新增，后自动选中的逻辑
        if (this.contactDetail.isNewDate && !this.isNewDateSet) {
          const idIndex = this.selectedContacts.findIndex((item) => item.id == this.contactDetail?.id)
          //如果没有添加过就走点击选中的逻辑，否则直接走会取消勾选
          if (idIndex === -1) {
            this.toggleCheckbox(this.contactDetail, true)
          }
          this.isNewDateSet = true
        }
      } else {
        this.isFristSelectedContact = false
      }
      this.hasMore = true
      this.$forceUpdate()
    },

    destroyed() {
      this.setSelectContactsInExternal()
      if (!this.hasConfirm) {
        // this.setContactSelected(this.initSetContactSelected)
        // 页面销毁时, 如果点击左上角返回而不是点击页面底部按钮, 新添加或删除的操作无效
        this.setContactSelected(this.originSelectInfo)
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .page
    height 100%
    background-color #ffffff
  .custom-main
    background-color #f0f1f4 !important
  .no-data
    font-size 14px
    color #333333
    text-align center
    padding-top 120px
    .no-data-img
      width 100px
      height 100px
      margin-bottom 8px
    .no-data-text
      text-align center
  /deep/ .es-toast
    background-color #000000
    padding 12px 24px
  +b('select')
    /deep/ .es-main
      background-color #f0f1f4
    +e('navbar')
      /deep/ .es-navbar
        height 44px
        background-color #ffffff
    /deep/ .es-navbar__right
      width 28px
    /deep/ .es-navbar__title
      font-size 18px
    +e('header-tip')
      font-size 12px
      line-height 16px
      color #666666
      padding-bottom 5px
      text-align center
      background-color #ffffff
    // +e('flight-tip')
    // padding 8px 12px
    // background linear-gradient(to right, #fff4ee, #fefefe)
    // color #FF6221
    // font-size 12px
    +e('tips')
      color #1167E5
      background linear-gradient(to right, #edf4ff, #fefefe)
      font-size 12px
      padding 8px 12px
    +e('contact_bg')
      display flex
      align-items center
      margin 7px 12px
      overflow-x auto
      scrollbar-width none /* firefox */
      -ms-overflow-style none /* IE 10+ */
      &::-webkit-scrollbar
        display none /* Chrome Safari */
    +e('contact-name')
      font-size 12px
      color #333333
      margin-right 4px
      line-height 12px
    +e('contact-img')
      color #BBBBBB
      width 12px
      height 12px
    +e('contact')
      flex-grow 0
      border-radius 4px
      font-family PingFangSC-Regular
      font-size 12px
      color #333333
      height 28px
      align-items center
      background #F3F4F5
      margin-right 8px
      padding 0px 10px
      display flex
      white-space nowrap
    +e('add')
      padding 10px 12px 0 12px
      font-family PingFangSC-Medium
    +e('content')
      background-color #ffffff
      border-radius 8px
      margin 10px 12px 0 12px
      .page-card
        position relative
        &::after
          border-bottom 1px solid #F0F2F7
          position absolute
          box-sizing border-box
          content ''
          pointer-events none
          right 0
          left 16px
          bottom 0
          transform scaleY(0.5)
        .del-box
          display flex
          justify-content flex-end
          align-items center
          border-radius 8px
          font-size 14px
          font-weight 500
          font-family PingFangSC-Regular
          height 100%
          background #F93822
          padding-right 24px
        .card
          display flex
          padding 20px 16px
          background #fff
          border-radius 8px
          .card-left
            align-self center
            .checkbox-container
              display flex
              align-items center
              padding-right 12px
            .icon-checkbox__disable
              display inline-block
              width 16px
              height 16px
              border 1px solid #D4D3D3
              border-radius 100%
              background #eeeeee
          .card-main
            flex 1
            display flex
            flex-direction column
            justify-content center
            .card-title
              display flex
              align-items center
              .username
                font-size 16px
                line-height 22px
                font-family PingFangSC-Medium
                color #333333
                font-weight 500
                display inline-block
                max-width 112px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
                margin-right 4px
              .english-name
                color #999999
                font-size 14px
                margin-right 6px
                display inline-block
                max-width 89px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
              .english-name-show
                font-size 16px
                color #333333
                max-width 120px
                font-family PingFangSC-Medium
              .card-tag
                color #666
                border 1px solid #ccc
                border-radius 4px
                display inline-block
                line-height 1
                font-size 12px
                padding 2px
                transform scale(0.83)
                align-self center
              .card-tag__common
                color #2EA761
              .card-tag__self
                border-color #82CAA0
                color #2EA761
              .card-tag__employee
                color #1473FF
                border-color #73ACFF
              .card-tag__external
                color #999999
                border-color #999999
              .card-tag__disabled
                color #999999
                border-color #999999
            .card-info
              display flex
              flex-direction column
              color #666666
              font-size 12px
              line-height 17px
              margin-top 4px
              word-break break-all
            .card-tip
              display flex
              flex-direction row
              align-items center
              font-size 12px
              color #f93822
              margin-top 8px
            .id-tip
              color #FF4129
              font-size 12px
              display inline-flex
              align-items center
              &-icon
                width 5px
                height 9px
                margin-left 4px
          .card-right
            flex none
            width 18px
            margin-left 8px
            align-self center
            color #666666
    +e('scroll-container')
      // height 100%
      // position relative
      // overflow-y auto
      background-color #f0f1f4
      padding-bottom 12px
      padding-top 1px
      .bottom-tip
        text-align center
        font-size 12px
        padding 10px
        color #999999
    +e('footer')
      flex 1
      padding 16px
      box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
      background #ffffff
      z-index 1
      .submit-button
        font-size 16px
        border-radius 8px !important
        background-color #FF6400
        border-color #FF6400
</style>

<script name='json'>
  module.exports = {
    // "navigationBarTitleText": "选择出行人",
    usingComponents: {
      'es-card-del': '@didi/es-mpx-ui/lib/card-del/index',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-button': '@didi/es-mpx-ui/lib/button',
      'checkbox-icon': './components/checkbox-icon',
      'es-toast': '@didi/es-mpx-ui/lib/toast/index',
      'search-input': './components/search-input',
      'add-button': './components/add-button',
      'es-over-layout': '@/es-mpx-ui/lib/layout',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog',
      'contact-dialog': './components/contact-dialog/index',
      'student-confirm-dialog': './components/contact-dialog/student-confirm-dialog',
      'student-dialog': './components/contact-dialog/student-dialog',
      'child-dialog': './components/contact-dialog/child-dialog',
      'supply-info': './components/supply-info',
    }
  }
</script>
